module.exports = __webpack_public_path__ + "img/logo_page.14698ac0.svg";